import { render, staticRenderFns } from "./FooterBottom.vue?vue&type=template&id=b0df7668&"
import script from "./FooterBottom.vue?vue&type=script&lang=ts&"
export * from "./FooterBottom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports